import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./FloatingWhatsapp.css";

const FloatingWhatsapp = () => {
  return (
    <a
      href="https://wa.me/573133853521?text=Hola%2C%20quiero%20más%20información%20sobre%20EduIAlogic"
      className="floating-whatsapp"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </a>
  );
};

export default FloatingWhatsapp;
